// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YesNoPopUp-pop-up-area[data-v-b61f6768]{text-align:center}.YesNoPopUp-pop-up-area i[data-v-b61f6768]{display:block;font-size:40px;padding:10px;color:#f77a7a}.YesNoPopUp-pop-up-area button[data-v-b61f6768]{margin:10px 5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
